import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function user(params: any): any {
    const { search, limit, pages } = params.data
    return api.get(`${URL.USER_GET}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}

function createUser(params: any): any {
    const { data } = params
    return api.create(URL.USER_POST, data);
}
function updateUser(params: any): any {
    const { data } = params
    return api.create(URL.USER_UPDATE, data);
}
function deleteUser(params: any): any {
    const { data } = params;
    return api.delete(`${URL.USER_DELETE}?_id=${data?.id}`);
}

export { user, createUser, updateUser, deleteUser }